import {observer} from 'mobx-react';
import {withState, t} from 'shared/core';
import {ScheduleEditFlowState, steps} from '../state';
import {Flow} from 'main/components';
import {Steps} from './steps';

const ScheduleEditFlow = observer(({uiState}) => {
  const {schedule, match} = uiState;

  return (
    <Flow
      name={schedule.name || t('time_tracking.manage.schedules.Untitled schedule')}
      backTitle={t('time_tracking.manage.schedules.Schedules')}
      backRoute={'/schedules'}
      steps={steps}
      component={Steps}
      uiState={uiState}
      baseUrl={`/schedules/${match.params.id}/edit`}
      onStepSubmitted={step => uiState.onStepSubmitted(step)}
    />
  );
});

export default withState(ScheduleEditFlow, ScheduleEditFlowState);
